module.exports = __webpack_public_path__ + "static/img/main-navigation-icon03.f2f4268a.svg";